import { useQuery } from "@tanstack/react-query";
import useApiDashboard from "./useApiDashboard";
import DashboardParams from "../interfaces/dashboardParams";

const useDashboardHistory = (token: string, params: DashboardParams) => {
    const { listHistory } = useApiDashboard();

    return useQuery({
        queryKey: ["dashboardHistory", params, token],
        queryFn: () => listHistory(token, params)
    })
}

export default useDashboardHistory;